import { FC, useState } from "react";

import { copy } from "shared/assets";
import { Button } from "shared/components";
import { Spacer } from "shared/layout";
import { TinyText } from "shared/styles";
import { ITheme } from "shared/types";
import {
  StyledCopyClipboard,
  StyledCopyClipboardButton,
  StyledCopyClipboardField,
  StyledCopyClipboardForm,
} from "./styles";

interface Props {
  label?: string;
  copyText: string;
}

export const ClipboardField: FC<Props> = ({ label, copyText }) => {
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(copyText);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Spacer size="s">
      {label && <TinyText>{label}</TinyText>}
      <StyledCopyClipboard>
        <StyledCopyClipboardForm>
          <StyledCopyClipboardField
            type="text"
            value={copyText}
            autoFocus
            readOnly
          />
        </StyledCopyClipboardForm>
        <StyledCopyClipboardButton>
          <Button
            onClick={copyLink}
            theme={ITheme.tertiary}
            size="xs"
            data-testid="copy_clipboard_button"
          >
            {copied ? copy.clipboard.copied : copy.clipboard.copy}
          </Button>
        </StyledCopyClipboardButton>
      </StyledCopyClipboard>
    </Spacer>
  );
};
